<style lang="stylus" scoped>
.main
    padding:0 56px;
    .title
        height:40px;
        font-size:28px;
        font-weight:500;
        color:rgba(7,19,54,1);
        line-height:40px;
    .desc
        height:20px;
        font-size:14px;
        font-weight:400;
        color:rgba(7,19,54,0.4);
        line-height:20px;
        margin-top:8px;
        margin-bottom:15px;
    .forgetPaw
        display:flex;
        justify-content:flex-end;
        color:#2751CB;
        font-size:14px;
        margin-right:10px;
        cursor: pointer;
    .f-input
        margin-top:10px;
    .iptverifycode
        margin-top:10px;
    .f-btn
        width:330px;
        height:48px;
        background:rgba(39,81,203,1);
        border-radius:24px;
        border:1px solid rgba(39,81,203,1);
        margin-top:15px;
        font-size:16px;
        font-weight:500;
    .agreement
        display:flex;
        cursor: pointer;
        margin-top:15px;
        height:20px;
        line-height:20px;
        font-size:14px;
        font-weight:400;
        align-items:center;
        .a-img
            width:16px;
            height:16px;
        .a-desc
            width:112px;
            color:rgba(7,19,54,0.4);
            margin-left:5px;
        .a-name
            color:rgba(7,19,54,0.8);
    .other
        margin-top:25px;
        .o-title
            width:84px;
            height:20px;
            font-size:14px;
            font-weight:400;
            color:rgba(7,19,54,0.4);
            line-height:20px;
        .o-list
            display:flex;
            justify-content:space-between;
            align-items:center;
            .o-lists
                display:flex;
                align-items:center;
                cursor: pointer;
                .o-l-img
                    width:20px;
                    height:20px;
                    margin-right:3px;
                .o-l-name
                    height:22px;
                    font-size:16px;
                    font-weight:400;
                    color:rgba(39,81,203,1);
                    line-height:22px;
</style>
<style lang="stylus">
.f-input
    .el-input__inner
        width:330px;
        height:48px;
        background:rgba(251,251,251,1);
        border-radius:24px;
        border:1px solid rgba(235,235,235,1);
.iptverifycode
    .el-input__inner
        width:207px;
        height:48px;
        background:rgba(251,251,251,1);
        border-radius:24px;
        border:1px solid rgba(235,235,235,1);
</style>

<template>
  <div>
    <el-dialog
      :visible.sync="loginModal"
      @close="modalHandleClose"
      :close-on-click-modal="false"
      append-to-body
      show-close
      width="483px">
        <div class="main" v-if="type == 'login'" key="logins">
            <div class="title">账号密码登录</div>
            <div class="desc">忘记密码请使用手机验证登录</div>
            <el-form :model="loginform" :rules="loginRules" ref="loginform">
                <el-form-item prop="account">
                    <el-input class="f-input" v-model.trim="loginform.account" @keyup.enter.native="LoginSubmitForm('loginform')" placeholder="输入手机号"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input class="f-input" type="password" v-model.trim="loginform.password" @keyup.enter.native="LoginSubmitForm('loginform')" placeholder="输入密码"></el-input>
                </el-form-item>
                <div class="forgetPaw" @click=" type = 'findPaw' ">忘记密码？</div>
                <el-form-item>
                    <el-button class="f-btn" @click="LoginSubmitForm('loginform')" :loading="loginning" type="primary">确 定</el-button>
                </el-form-item>
                <el-form-item>
                    <div class="agreement">
                        <img v-if="read" src="/static/img/check.png" class="a-img" @click="checkRead">
                        <img v-if="!read" src="/static/img/check1.png" class="a-img" @click="checkRead">
                        <div class="a-desc" @click="checkRead">已阅读并同意平台</div>
                        <router-link class="a-name" target="_blank" :to="{path: '/agreement/userAgreement'}">《用户协议》</router-link>
                        <router-link class="a-name" target="_blank" :to="{path: '/agreement/payAgreement'}">《支付协议》</router-link>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div class="other">
                        <el-divider><span class="o-title">其他登录方式</span></el-divider>
                        <div class="o-list">
                            <div class="o-lists" @click=" type = 'note' ">
                                <img class="o-l-img" src="/static/img/phone_login.png">
                                <span class="o-l-name">手机验证登录/注册</span>
                            </div>
                            <div class="o-lists" @click="qqandwxLogin('wx')">
                                <img class="o-l-img" src="/static/img/weixin_login.png">
                                <span class="o-l-name">微信授权登录</span>
                            </div>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>

        <div class="main" v-if="type == 'note'" key="notes">
            <div class="title">手机号登录/注册</div>
            <div class="desc">未注册的用户手机号验证即可注册</div>
            <el-form :model="noteform" :rules="noteRules" ref="noteform">
                <el-form-item prop="phone">
                    <el-input class="f-input" v-model.trim="noteform.phone" @keyup.enter.native="NoteSubmitForm('noteform')" placeholder="输入手机号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-row type="flex" align="middle">
                        <el-col :span="15">
                            <el-form-item prop="verifycode">
                                <el-input class="iptverifycode" v-model.trim="noteform.verifycode" @keyup.enter.native="NoteSubmitForm('noteform')" placeholder="输入验证码"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" :offset="1">
                            <el-button v-if="!noteform.starttime"  type="primary" plain @click.stop="notegetcode">获取验证码</el-button>
                            <el-button v-else disabled plain size="medium" type="primary">{{noteform.runtime}}秒后重发</el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item>
                    <el-button class="f-btn" @click="NoteSubmitForm('noteform')" :loading="loginnings" type="primary">确 定</el-button>
                </el-form-item>
                <el-form-item>
                    <div class="agreement">
                        <img v-if="read" src="/static/img/check.png" class="a-img" @click="checkRead">
                        <img v-if="!read" src="/static/img/check1.png" class="a-img" @click="checkRead">
                        <div class="a-desc" @click="checkRead">已阅读并同意平台</div>
                        <router-link class="a-name" target="_blank" :to="{path: '/agreement/userAgreement'}">《用户协议》</router-link>
                        <router-link class="a-name" target="_blank" :to="{path: '/agreement/payAgreement'}">《支付协议》</router-link>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div class="other">
                        <el-divider><span class="o-title">其他登录方式</span></el-divider>
                        <div class="o-list">
                            <div class="o-lists" @click=" type = 'login' ">
                                <img class="o-l-img" src="/static/img/account_login.png">
                                <span class="o-l-name">账号密码登录</span>
                            </div>
                            <div class="o-lists" @click="qqandwxLogin('wx')">
                                <img class="o-l-img" src="/static/img/weixin_login.png">
                                <span class="o-l-name">微信授权登录</span>
                            </div>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>

        <div class="main" v-if="type == 'weixin'" key="weixins">
            <div class="title">微信绑定手机号</div>
            <div class="desc">您的微信还未绑定手机，请完成绑定</div>
            <el-form :model="weixinform" :rules="weixinRules" ref="weixinform">
                <el-form-item prop="phone">
                    <el-input class="f-input" v-model.trim="weixinform.phone" @keyup.enter.native="WeixinSubmitForm('weixinform')" placeholder="输入手机号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-row type="flex" align="middle">
                        <el-col :span="15">
                            <el-form-item prop="verifycode">
                                <el-input class="iptverifycode" v-model.trim="weixinform.verifycode" @keyup.enter.native="WeixinSubmitForm('weixinform')" placeholder="输入验证码"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" :offset="1">
                            <el-button v-if="!weixinform.starttime"  type="primary" plain @click.stop="notegetcode">获取验证码</el-button>
                            <el-button v-else disabled plain size="medium" type="primary">{{weixinform.runtime}}秒后重发</el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item>
                    <el-button class="f-btn" @click="WeixinSubmitForm('weixinform')" :loading="weixinlogin" type="primary">确 定</el-button>
                </el-form-item>
                <el-form-item>
                    <div class="agreement">
                        <img v-if="read" src="/static/img/check.png" class="a-img" @click="checkRead">
                        <img v-if="!read" src="/static/img/check1.png" class="a-img" @click="checkRead">
                        <div class="a-desc" @click="checkRead">已阅读并同意平台</div>
                        <router-link class="a-name" target="_blank" :to="{path: '/agreement/userAgreement'}">《用户协议》</router-link>
                        <router-link class="a-name" target="_blank" :to="{path: '/agreement/payAgreement'}">《支付协议》</router-link>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div class="other">
                        <el-divider><span class="o-title">其他登录方式</span></el-divider>
                        <div class="o-list">
                            <div class="o-lists" @click=" type = 'login' ">
                                <img class="o-l-img" src="/static/img/account_login.png">
                                <span class="o-l-name">账号密码登录</span>
                            </div>
                            <div class="o-lists" @click=" type = 'note' ">
                                <img class="o-l-img" src="/static/img/phone_login.png">
                                <span class="o-l-name">手机验证登录/注册</span>
                            </div>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>

        <div class="main" v-if="type == 'findPaw'" key="findPaw">
            <div class="title">找回密码</div>
            <el-form :model="passwordresetform" :rules="findpasswordRules" ref="passwordresetform">
                <el-form-item prop="account">
                    <el-input class="f-input" v-model.trim="passwordresetform.account" placeholder="输入注册手机号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-row type="flex" align="middle">
                        <el-col :span="15">
                            <el-form-item prop="verifycode">
                                <el-input class="iptverifycode" v-model.trim="passwordresetform.verifycode" placeholder="输入验证码"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" :offset="1">
                            <el-button v-if="!passwordresetform.starttime"  type="primary" plain @click.stop="cpwdgetcode">获取验证码</el-button>
                            <el-button v-else disabled plain size="medium" type="primary">{{passwordresetform.runtime}}秒后重发</el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item prop="password">
                    <el-input class="f-input" type="password" v-model.trim="passwordresetform.password" placeholder="请输入新密码"></el-input>
                </el-form-item>
                <el-form-item prop="repassword">
                    <el-input class="f-input" type="password" v-model.trim="passwordresetform.repassword" placeholder="请确认新密码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class="f-btn" @click="resetfn('passwordresetform')" :loading="passwordresetning" type="primary">确 定</el-button>
                </el-form-item>
                <el-form-item>
                    <div class="logintipwrap">
                        <a @click="type = 'login'" href="javascript:;">&lt;&lt;返回登录</a>
                    </div>
                </el-form-item>
            </el-form>
        </div>

    </el-dialog>
  </div>
</template>

<script>
import {createRandom} from '@/common/js/createRandom';
import sockets from '@/socket';

export default {
    name: 'Login',
    data() {
        var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机不能为空'))
            }
            if (/^1[3|4|5|6|7|8|9]\d{9}$/.test(value)) {  //验证手机号第二位可为6，
                if( this.type === 'note' ){
                  this.$http.get('/isrepetitionbyphone', {params:{phone: value}}).then(res => {
                    if (res.data.isRepetition === 0) {
                      this.noteform.newphone = true;
                      this.noteform.type = 'register';
                      callback()
                    } else {
                      this.noteform.newphone = false;
                      this.noteform.type = 'login';
                      callback()
                    }
                  })
                }else if(this.type === 'weixin'){
                    this.$http.get('/isrepetitionbyphone', {params:{phone: value}}).then(res => {
                    if (res.data.isRepetition === 0) {
                      this.weixinform.newphone = true;
                      this.weixinform.type = 'register';
                      callback()
                    } else {
                      this.weixinform.newphone = false;
                      this.weixinform.type = 'login';
                      callback()
                    }
                  })
                }else if (this.type === 'findPaw'){
                    this.passwordresetform.accounttype = 'phone';
                    callback()
                }else{
                    callback()
                }
            } else {
                return callback(new Error('手机号码错误'))
            }
        };
        const validatePass = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('密码不能为空'));
          } else {
            if( this.type === "findPaw" && this.passwordresetform.repassword !== '' ){
              // 对第二个密码框单独验证
              this.$refs.passwordresetform.validateField('repassword');
            }
            callback();
          }
        };
        const validatePassCheck = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请确认密码'));
            } else if (this.type === "findPaw" && value !== this.passwordresetform.password) {
                callback(new Error('两次输入密码不一致'));
            } else {
                callback();
            }
        };
        return {
            baseurl: $conf.baseUrl,
            read:true, //是否已读协议
            type: 'login',   // login note weixin
            loginModal: false,
            loginform:{
                account:'',
                password:''
            },
            loginRules: {
                account: [
                  { required: true, validator: checkPhone, trigger: 'blur' }
                ],
                password: [
                  { required: true, message: '密码不能为空', trigger: 'blur' }
                ]
            },
            loginning: false,
            noteform:{
                phone:'',
                verifycode:'',
                againtime: 60,
                runtime: 60,
                starttime: false,
                type:'login',
                newphone:false
            },
            noteRules:{
                phone: [
                  { required: true, validator: checkPhone, trigger: 'blur' },
                ],
                verifycode: [
                  { required: true, min: 4, max: 6, message: '验证码错误', trigger: 'blur' }
                ]
            },
            loginnings:false,
            weixinform:{
                phone:'',
                verifycode:'',
                againtime: 60,
                runtime: 60,
                starttime: false,
                type:'login',
                newphone:false
            },
            weixinRules:{
                phone: [
                  { required: true, validator: checkPhone, trigger: 'blur' },
                ],
                verifycode: [
                  { required: true, min: 4, max: 6, message: '验证码错误', trigger: 'blur' }
                ]
            },
            weixinlogin:false,
            passwordresetform:{
                account: '',
                verifycode: '',
                password: '',
                repassword: '',
                accounttype: 'phone',
                againtime: 60,
                runtime: 60,
                starttime: false
            },
            findpasswordRules:{
                account: [
                  { required: true, validator: checkPhone, trigger: 'blur' },
                ],
                password: [
                  { validator: validatePass, trigger: 'blur' },
                  { min: 6, message: '请输入不少于6位数密码', trigger: 'blur' }
                ],
                verifycode: [
                  { required: true, min: 4, max: 6, message: '验证码错误', trigger: 'blur' }
                ],
                repassword: [
                  { validator: validatePassCheck, trigger: 'blur' },
                  { min: 6, message: '请输入不少于6位数密码', trigger: 'blur' }
                ]
            },
            passwordresetning: false,
        }
    },
    computed: {
        loginModalStatus() {
            return this.$store.state.loginModalStatus;
        }
    },
    beforeMount() {
        this.loginModal = this.loginModalStatus.display;
        this.type = this.loginModalStatus.type;

        // 账号封禁
        if (this.$route.query.errmsg == '1') {
          this.$alert('您已经被禁止登陆！', '登陆错误提示', {
            confirmButtonText: '确定',
            type: 'error',
            callback: action => {
              if( action == 'confirm' ){
                window.location.replace(window.location.href.split('?')[0]);
              }
            }
          });
        }

        if( this.$route.query.showtype ) {
          this.$store.commit('changeLoginModalStatus', {display: true, type: 'login'});
        }
    },
    methods: {
        modalHandleClose() {
            this.$store.commit('changeLoginModalStatus', {display: false , type : 'login'});
        },
        qqandwxLogin(type) {
          let _type = type === 'qq' ? 'qqlogin' : 'weixinweblogin';
          this.$http.get('isWxUser').then((res) =>{
              // console.log('isWxUser',res);
              if(res.data.data.wxUser){
                this.$store.commit('changeWxUser',true);
                this.type = 'weixin';
              }else{
                this.$store.commit('changeWxUser',false);
                window.location.href = `${this.baseurl}${_type}`;
              };
          }).catch(error =>{
              console.log('error',error);
          });
          // if(this.$store.state.wxUserStatus){
          //   this.type = 'weixin';
          // }else{
          //   window.location.href = `${this.baseurl}${_type}`;
          // }
          // window.location.href = `${this.baseurl}${_type}`;
        },
        //选择已读协议
        checkRead(){
            this.read = !this.read;
        },
        LoginSubmitForm(formName){
            if( this.loginning ){
                return;
            }
            if( !this.read ){
                this.$message.error( '未同意平台《用户协议》、《支付协议》' );
                return false;
            }
            this.$refs[formName].validate((valid) => {
                if( valid ){
                    this.loginning = true;
                    let param = { password: this.loginform.password, type: 'phone' , phone: this.loginform.account , pwdOrCode :'pwd',remember:'on'};
                    this.$http.post('login', param).then(response => {
                        if( response.data.retcode == $conf.RETCODE_OK ){
                            // 从哪来回哪去
                            if( this.$route.query.callbackurl && this.$route.query.showtype ){
                                window.location.replace(this.$route.query.callbackurl);
                            }

                            let v = response.data.data;
                            // if (v.phone === null || v.phone === '') {
                            //     this.$store.commit('changebindPhone', true)
                            // }
                            this.$store.commit('changeloginStatus', true);
                            this.$store.commit('changeMineInfo', v);
                            /* socket */
                            if(window.socket){
                                window.socket.close();
                            }
                            sockets(v.id);
                            this.modalHandleClose();
                        }else{
                            this.$message.error( response.data.errmsg );
                        }
                        this.loginning = false;
                    }).catch(err => {
                        if( err.response ) {
                            switch( err.response.status ) {
                                case 422:
                                this.$message.error( '验证码错误！' );
                            }
                        }
                        this.loginning = false;
                    });
                }else{
                    console.log('2222');
                }
            });
        },
        //找回密码获取验证码
        cpwdgetcode() {
          let accpet= "";
          this.$refs.passwordresetform.validateField('account', cb => { accpet = cb });
          if( accpet != "" ){
              return false;
          }
          this.starttime('passwordresetform');
          let param = { type: this.passwordresetform.accounttype};
          param[this.passwordresetform.accounttype] = this.passwordresetform.account;
          this.$http.post('passwordreset/send', param).then(response => {
              if( response.data.retcode == $conf.RETCODE_OK ){
                  this.$message.success( '获取验证码成功，请查收！' );
              }else{
                  this.passwordresetform.runtime = 0;
                  this.$message.error( response.data.errmsg );
              }
          }).catch(err => {
              if( err.response ) {
                  switch( err.response.status ) {
                      case 429:
                          this.$message.error( '发送验证码太频繁，请稍后重试！' );
                  }
              }
          });
        },
        //获取验证码
        notegetcode(){
            let url = 'sms/verifycode';
            let param = {};
            if(this.type == 'note'){
                param = { phone: this.noteform.phone, type: this.noteform.type }
            }else if(this.type == 'weixin'){
                param = { phone: this.weixinform.phone, type: this.weixinform.type }
            }
            this.$http.post(url, param).then(response => {
                if( response.data.retcode == $conf.RETCODE_OK ){
                    if(this.type == 'note'){
                        this.starttime('noteform');
                    }else if(this.type == 'weixin'){
                        this.starttime('weixinform');
                    };
                    this.$message.success( '获取验证码成功，请查收！' );
                }else{
                    if(this.type == 'note'){
                        this.noteform.runtime = 0;
                    }else if(this.type == 'weixin'){
                        this.weixinform.runtime = 0;
                    };
                    this.$message.error( response.data.errmsg );
                }
            }).catch(err => {
                if( err.response ) {
                    switch( err.response.status ) {
                        case 429:
                        this.$message.error( '发送验证码太频繁，请稍后重试！' );
                    }
                }
            });
        },
        resetfn() {
          if( this.passwordresetning ){
            return;
          }
          this.$refs.passwordresetform.validate((valid) => {
            if (valid) {
              this.passwordresetning = true;
              let param = { password: this.passwordresetform.password, code: this.passwordresetform.verifycode, type: 'phone' };
              param[this.passwordresetform.accounttype] = this.passwordresetform.account;
              this.$http.post('passwordreset/reset', param).then(response => {
                if( response.data.retcode == $conf.RETCODE_OK ){
                  this.$message.success( '重置密码成功！' );
                  this.modalHandleClose();
                  this.$refs.passwordresetform.resetFields();
                }else{
                  this.$message.error( response.data.errmsg );
                }
                this.passwordresetning = false;
              }).catch(err => {
                this.passwordresetning = false;
              });
            }
          });
        },
        NoteSubmitForm(formName){
            if( this.loginnings ){
                return;
            };
            if( !this.read ){
                this.$message.error( '未同意平台《用户协议》、《支付协议》' );
                return false;
            }
            this.$refs[formName].validate((valid) => {
                if( valid ){
                    this.loginnings = true;
                    if(this.noteform.newphone){
                        let param = {phone :this.noteform.phone,code: this.noteform.verifycode};
                        this.$http.post('new/register',param).then(res => {
                            if(res.data.retcode == $conf.RETCODE_OK){
                                // 从哪来回哪去
                                if( this.$route.query.callbackurl && this.$route.query.showtype ){
                                    window.location.replace(this.$route.query.callbackurl);
                                };
                                let v = res.data.data;
                                // if (v.phone === null || v.phone === '') {
                                //     this.$store.commit('changebindPhone', true)
                                // }
                                this.$store.commit('changeloginStatus', true);
                                this.$store.commit('changeMineInfo', v);
                                /* socket */
                                if(window.socket){
                                    window.socket.close();
                                };
                                sockets(v.id);
                                this.modalHandleClose();
                            }else{
                                this.$message.error( res.data.errmsg );
                            };
                            this.loginnings = false;
                        })
                    }else{
                        let param = {  type: 'phone' , phone: this.noteform.phone , pwdOrCode :'code' , code: this.noteform.verifycode ,remember:'on'};
                        this.$http.post('login',param).then(res =>{
                            if(res.data.retcode == $conf.RETCODE_OK){
                                // 从哪来回哪去
                                if( this.$route.query.callbackurl && this.$route.query.showtype ){
                                    window.location.replace(this.$route.query.callbackurl);
                                };
                                let v = res.data.data;
                                // if (v.phone === null || v.phone === '') {
                                //     this.$store.commit('changebindPhone', true)
                                // }
                                this.$store.commit('changeloginStatus', true);
                                this.$store.commit('changeMineInfo', v);
                                /* socket */
                                if(window.socket){
                                    window.socket.close();
                                };
                                sockets(v.id);
                                this.modalHandleClose();
                            }else{
                                this.$message.error( res.data.errmsg );
                            };
                            this.loginnings = false;
                        }).catch(err => {
                            if( err.response ) {
                                switch( err.response.status ) {
                                    case 422:
                                    this.$message.error( '验证码错误！' );
                                }
                            };
                            this.loginnings = false;
                        })
                    }
                }else{
                  console.log('22222')
                }
            });
        },
        WeixinSubmitForm(formName){
            if( this.weixinlogin ){
                return;
            };
            if( !this.read ){
                this.$message.error( '未同意平台《用户协议》、《支付协议》' );
                return false;
            }
            this.$refs[formName].validate((valid) => {
                if( valid ){
                    this.weixinlogin = true;
                    let param = {phone :this.weixinform.phone,code: this.weixinform.verifycode};
                    this.$http.post('webbind',param).then(res => {
                        if(res.data.retcode == $conf.RETCODE_OK){
                            // 从哪来回哪去
                            if( this.$route.query.callbackurl && this.$route.query.showtype ){
                                window.location.replace(this.$route.query.callbackurl);
                            };
                            let v = res.data.data;
                            // if (v.phone === null || v.phone === '') {
                            //     this.$store.commit('changebindPhone', true)
                            // }
                            this.$store.commit('changeloginStatus', true);
                            this.$store.commit('changeMineInfo', v);
                            /* socket */
                            if(window.socket){
                                window.socket.close();
                            };
                            sockets(v.id);
                            this.modalHandleClose();
                        }else{
                            this.$message.error( res.data.errmsg );
                        };
                        this.weixinlogin = false;
                    })
                }else{
                  console.log('3333')
                }
            });
        },
        setTime(ref) {
          setTimeout(() => {
            if( this[ref].runtime <= 0 ){
              this[ref].starttime = false;
            }else{
              this[ref].runtime -= 1;
              this.setTime(ref);
            }
          }, 1000);
        },
        starttime(ref) {
          this[ref].starttime = true;
          this[ref].runtime = this[ref].againtime;
          this.setTime(ref);
        },
    },
    watch: {
        loginModalStatus: {
            deep: true,
            handler(v, ov) {
                this.loginModal = v.display;
                this.type = v.type;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/login/index.vue